/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var UsersFilter;
(function (UsersFilter) {
    UsersFilter["Keycloak"] = "KEYCLOAK";
    UsersFilter["Service"] = "SERVICE";
})(UsersFilter || (UsersFilter = {}));
export function UsersFilterFromJSON(json) {
    return UsersFilterFromJSONTyped(json, false);
}
export function UsersFilterFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function UsersFilterToJSON(value) {
    return value;
}
